<wb-heading *ngIf="title" size="l">{{ title | translate }}</wb-heading>
<wb-tabs selected="{{ searchOptions.entity }}" *ngIf="showTabNavigation()" theme="dark">
  <wb-tab
    *ngFor="let entity of entitiesWithContent"
    (click)="openTab(entity)"
    name="{{ entity }}"
    selected="entity === searchOptions.entity"
    >{{ entity + 'S' | translate }}
    <wb-counter
      class="wb-margin-start-xxs"
      max="9999"
      value="{{ assetsCount[entity] }}"
      theme="dark"
      variant="secondary"
    ></wb-counter
  ></wb-tab>
</wb-tabs>

<ng-container *ngIf="!isError; else errorTemplate">
  <ng-container *ngIf="filterGroups.length">
    <div class="filter-background"></div>
    <mb-filtertool-narrow
      *ngIf="searchOptions.entity"
      [filterGroups]="filterGroups"
      [activeEntity]="searchOptions.entity"
      (allFiltersClickEvent)="showAll()"
    ></mb-filtertool-narrow>
  </ng-container>
  <div class="info" *ngIf="searchOptions.entity">
    <wb-text>{{
      (assetCount === 1 ? searchOptions.entity + '_N' : searchOptions.entity + 'S_N')
        | translate : { count: assetCount }
    }}</wb-text>
    <wb-select compact theme="dark">
      <select name="model" (ngModelChange)="onSortChange($event)" [(ngModel)]="searchOptions.sortOption">
        <option *ngFor="let sortOption of sortOptions" [ngValue]="sortOption">
          {{ sortOption.label | translate }}
        </option>
      </select>
    </wb-select>
  </div>

  <wb-grid>
    <wb-grid-row>
      <ng-container *ngIf="cards.length; else noCardsLoaded">
        <wb-grid-col
          mq1="12"
          mq2="12"
          mq3="6"
          mq4="4"
          mq5="4"
          mq6="3"
          *ngFor="let item of cards | slice : 0 : shownCardsCount"
        >
          <ng-container [ngSwitch]="searchOptions.entity">
            <mb-event-card
              *ngSwitchCase="'EVENT'"
              [titleHash]="item.titleHash"
              [headline]="item.headline"
              [image]="$any(item.media)"
              [darkTheme]="true"
              [link]="item.link"
              [startDate]="item.startDate"
              [endDate]="item.endDate"
              [timezoneOffset]="item.timezoneOffset"
              [location]="item.location"
            >
            </mb-event-card>
            <mb-media-card
              *ngSwitchDefault
              [assetType]="searchOptions.entity"
              [headline]="item.headline!"
              [media]="item.media"
              [link]="item.link!"
              [topline]="item.topline"
              [toplineIcon]="item.toplineIcon"
              [text]="item.text"
              [metaItems]="item.metaItems"
              [actions]="item.actions"
              [data]="item"
              [videoDuration]="item.videoDuration"
              [assetCount]="item.assetCount"
              [fuelLabel]="item.fuelLabel"
            ></mb-media-card>
          </ng-container>
        </wb-grid-col>
      </ng-container>
      <ng-template #noCardsLoaded>
        <wb-grid-col
          mq1="12"
          mq2="12"
          mq3="6"
          mq4="4"
          mq5="4"
          mq6="3"
          *ngFor="let i of [].constructor(initialCardAmount)"
        >
          <wb-skeleton class="card-skeleton" theme="dark"></wb-skeleton>
        </wb-grid-col>
      </ng-template>
    </wb-grid-row>
  </wb-grid>

  <div *ngIf="assetCount" class="bottom-buttons">
    <wb-button
      *ngIf="assetCount > shownCardsCount && (searchOptions.page || 0) < maxPages"
      (click)="showMore()"
      variant="secondary"
      theme="dark"
      >{{ 'SHOW_MORE' | translate }}</wb-button
    >
    <wb-button *ngIf="showShowAllButton" (click)="showAll()" variant="secondary" theme="dark"
      ><wb-icon slot="icon" name="bds/arrow-right/24"></wb-icon>{{ 'ALL' | translate }}
      {{ this.searchOptions.entity + 'S' | translate }}</wb-button
    >
  </div>
</ng-container>

<ng-template #errorTemplate>
  <wb-error-section>
    <wb-heading size="s" tag="h2">{{ 'AN_ERROR_OCCURED' | translate }}</wb-heading>
    <wb-text size="l" tag="p">
      {{ 'AN_ERROR_OCCURED_MESSAGE' | translate }}
    </wb-text>
    <wb-button (click)="reload()" theme="dark" slot="footer" variant="secondary" size="l">{{
      'RELOAD' | translate
    }}</wb-button>
  </wb-error-section>
</ng-template>
